import React, { useState, useEffect ,useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, faEdit, faList, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
 import { format } from "date-fns";
import "./classes/SalesReport.css";
import { useReactToPrint } from "react-to-print";
import { toWords } from 'number-to-words';
import Pagination from "./Pagination";
import html2pdf from "html2pdf.js";

const API_BASE = configData.APP_URL;

const EstimateReport = () => {

    const initialForm = {  
        start_date:'',
        start_date_obj:null,
        end_date:'',
        end_date_obj:null,
        customer_name: ''
    };     

    const [formData, setFormData] = useState(initialForm);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [sales, setSales] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedId, setExpandedId] = useState(null);
    const [orderItems, setOrderItems] = useState({});
    const [submittedData, setSubmittedData] = useState(initialForm);

    const [currentPage, setCurrentPage] = useState(1);
    const reportPerPage = 15;

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setExpandedId(null);
        window.scrollTo(0,0);
    };

    const indexOfLastItem = currentPage * reportPerPage;
    const indexOfFirstItem = indexOfLastItem - reportPerPage;
    const currentSales = sales.slice(indexOfFirstItem, indexOfLastItem);

    // const totalPages = Math.ceil(sales.length / reportPerPage);

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [companyDetail, setCompanyDetail] = useState(null);
    const customers = [
        { id: 1, name: "Rahul Sharma" },
        { id: 2, name: "Anjali Verma" },
        { id: 3, name: "Mohit Patel" },
        { id: 4, name: "Sneha Kapoor" },
    ];
    const [formErrors, setFormErrors] = useState({}); 

    // const contentRef = useRef(null);
    // const handlePrint = useReactToPrint({
    //     contentRef: contentRef,
    //     documentTitle: "Sales Report",
    // });

    const [printType, setPrintType] = useState("receipt-58mm");
    const [showPrintPopup, setShowPrintPopup] = useState(false);

    const contentOrderRef = useRef(null);

    const handleOrderPrint = useReactToPrint({
    contentRef: contentOrderRef,
    documentTitle: selectedInvoice
        ? `Quotation-${selectedInvoice.estimate_number}`
        : "Quotation",
    });

    const printSale = (size) => {
        setPrintType(size);
        setShowPrintPopup(false);
        setTimeout(() => {
            handleOrderPrint();
        }, 0);
    };
    const getRowConfig = (type) => {
        switch (type) {
            case "invoice-a4":
            return { FIRST: 24, LAST: 18 };
            case "receipt-152mm":
            return { FIRST: 12, LAST: 5 };
            default:
            return { FIRST: 24, LAST: 18 };
        }
    };

    const invoiceRef = useRef();

    const handleSharePDF = async () => {
        if (!invoiceRef.current) return;
        
        // 1. Set the print type state (good for consistency)
        setPrintType("invoice-a4");
        const element = invoiceRef.current;

        // 2. FORCE VISIBILITY: Save original styles and override the CSS 'display: none'
        const originalStyle = element.getAttribute("style");
        element.style.cssText = "display: block !important; visibility: visible !important; position: static !important; background: white;";

        const opt = {
            margin: 0,
            filename: `estimate-${selectedInvoice?.estimate_number || 'export'}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { 
                scale: 2, 
                useCORS: true, 
                logging: false,
                // Give the browser a moment to render before the snapshot
                delay: 100 
            },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all", "css", "legacy"] }
        };

        try {
            // 3. Generate the PDF
            const pdfBlob = await html2pdf().set(opt).from(element).outputPdf("blob");

            // 4. RESTORE: Put the element back to its hidden state
            if (originalStyle) {
                element.setAttribute("style", originalStyle);
            } else {
                element.removeAttribute("style");
            }

            // 5. Handling the file (Download)
            const url = URL.createObjectURL(pdfBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = opt.filename;
            link.click();

            // 6. Handling the file (Share)
            if (navigator.share) {
                const file = new File([pdfBlob], opt.filename, { type: "application/pdf" });
                try {
                    await navigator.share({
                        files: [file],
                        title: "Invoice",
                        text: "Here is your invoice"
                    });
                } catch (err) {
                    console.log("Share cancelled or failed", err);
                }
            }
            
            // Clean up memory
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error("PDF Generation Error:", error);
            // Ensure style is restored even if it fails
            element.setAttribute("style", originalStyle || "");
        }
    };

    const exportSalesCSV = () => {

        if (!sales || sales.length === 0) {
            alert("No data available to export");
            return;
        }

        const formatDateForFile = (dateStr) => {
            if (!dateStr) return "";
            return dateStr.replaceAll("-", "").slice(2); // 2026-05-24 -> 240526
        };

        let fileName = "estimate_report";

        const safeCustomer = submittedData.customer_name
            ? submittedData.customer_name
                .toLowerCase()
                .replace(/\s+/g, "_")
                .replace(/[^a-z0-9_]/g, "")
            : "";

        if (safeCustomer) {
            fileName += `_${safeCustomer}`;
        }

        const from = formatDateForFile(submittedData.start_date);
        const to = formatDateForFile(submittedData.end_date);

        if (from || to) {
            fileName += `_${from}${to ? `_${to}` : ""}`;
        }

        fileName += ".csv";

        const metaRows = [
            ["Estimate Report"],
            safeCustomer ? [`Customer: ${submittedData.customer_name}`] : [],
            (submittedData.start_date || submittedData.end_date)
                ? [`Date Range: ${submittedData.start_date || ""} - ${submittedData.end_date || ""}`]
                : [],
            []
        ].filter(row => row.length > 0); // remove empty rows

        const headers = ["ID", "Estimate #", "Customer Name", "Total", "Date"];

        const rows = sales.map((sale) => {
            const id = sale.estimate_id ?? sale.id;
            const estimateNumber = sale.estimate_number ?? sale.estimate_number ?? sale.estimate ?? "";
            const customerName = sale.customer_name ?? sale.customer ?? "";
            const total = sale.total_amount ?? sale.total ?? sale.grand_total ?? 0;
            const date = sale.order_date ?? sale.created_at ?? sale.date ?? "";

            return [
                id,
                estimateNumber,
                customerName,
                Number(total).toFixed(2),
                date ? new Date(date).toLocaleString() : ""
            ];
        });

        const csvContent =
            [...metaRows, headers, ...rows]
                .map(row => row.map(field => `"${field}"`).join(","))
                .join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (date, field) => {
        setFormData(prev => ({
            ...prev,
            [`${field}_obj`]: date,                     
            [field]: date ? format(date, "yyyy-MM-dd") : '' 
        }));
    };


  const validateDates = (formData) => {
    let errors = {};

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };
  const fetchSales = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}estimate-api/estimate-report`);
      const data = await res.json();
      let list = [];
      if (Array.isArray(data)) list = data;
      else if (data?.data && Array.isArray(data.data)) list = data.data;
      else if (data?.sales && Array.isArray(data.sales)) list = data.sales;
      setSales(list);
    } catch (error) {
      console.error("Error fetching sales:", error);
      setSales([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderItems = async (transactionId, sale) => {
    if (orderItems[transactionId]) return;
    const inlineItems = sale?.items ?? sale?.order_items ?? sale?.orderItems;
    if (Array.isArray(inlineItems) && inlineItems.length > 0) {
      setOrderItems((prev) => ({ ...prev, [transactionId]: inlineItems }));
      return;
    }
    try {
      const res = await fetch(`${API_BASE}estimate-api/orders?id=${transactionId}`);
      const data = await res.json();
      let items = [];
      if (Array.isArray(data)) items = data;
      else if (data?.data && Array.isArray(data.data)) items = data.data;
      else if (data?.items && Array.isArray(data.items)) items = data.items;
      setOrderItems((prev) => ({ ...prev, [transactionId]: items }));
    } catch (error) {
      console.error("Error fetching order items:", error);
      setOrderItems((prev) => ({ ...prev, [transactionId]: [] }));
    }
  };

  const toggleOrders = (transactionId, sale) => {
    setExpandedId((prev) => (prev === transactionId ? null : transactionId));
    fetchOrderItems(transactionId, sale);
    setSelectedInvoice(sale);
  };

  useEffect(() => {
    fetchSales();
  }, []);
    // useEffect(() => {
    //     setLoading(true);
    //     setTimeout(() => {
    //         setSales(mockData);
    //         setLoading(false);
    //     }, 800);
    // }, []);
    const handleSubmit = async (e) => {
        e.preventDefault(); // stop page reload

        const errors = validateDates(formData);

        if (Object.keys(errors).length > 0) {
            // console.log("Validation errors:", errors);
            setFormErrors(errors); 
            return;
        }
        setFormErrors({});
        // console.log(formData);
        setSubmittedData({ ...formData });
        try {
        const response = await fetch(API_BASE+'estimate-api/submit-estimate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({formData: formData}),
        });
        const data = await response.json();
        // console.log(data.data.rows);
        let list = [];
        if (Array.isArray(data)) list = data;
        else if (data?.data && Array.isArray(data.data)) list = data.data;
        else if (data?.sales && Array.isArray(data.sales)) list = data.sales;
        setSales(list);
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
        }
        console.log("Form submitted:", formData);
    };

    const companydetails = async () => {
      try {
        const res = await fetch(API_BASE + "salesapi/showcom");
        const data = await res.json();
    
        if (data.company) {
          setCompanyDetail(data.company);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    useEffect(() => {
      companydetails();
    }, []);

    if (!companyDetail) return;

    function capitalizeWords(str) {
        return str
        .split(" ")
        .map(word => (word.toLowerCase() === "and" ? "and" : word.charAt(0).toUpperCase() + word.slice(1)))
        .join(" ");
    }
        const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this order?")) return;

    try {
      const res = await fetch(`${API_BASE}estimate-api/deleteestimate?id=${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to delete item");
      alert("Order deleted successfully");

      fetchSales();
    } catch (error) {
      console.error("Error deleting item:", error);
      alert(error.message);
    }
  };
    return (
        <div className="sales-report-page">
            <Helmet>
                <title>Estimate Report</title>
            </Helmet>
            <div className="sales-report-container">
                <h2 className="sales-report-title">
                    <FontAwesomeIcon icon={faList} /> Estimate Report
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="sales-report-filters">
                        <div className="order-search-container">
                            <label>Customer Name: </label>
                            <input 
                                type="text"
                                name="customer_name"
                                value={formData.customer_name}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label htmlFor="start_date">Start Date: </label>
                            <DatePicker
                                ref={startDateRef}
                                selected={formData.start_date_obj}
                                onChange={(date) => {handleDateChange(date, 'start_date');
                                    setTimeout(() => {
                                        const input = startDateRef.current?.input;
                                        if (input) {
                                            const len = input.value.length;
                                            input.setSelectionRange(len, len);
                                        }
                                    }, 0);
                                }}
                                name="start_date"
                                id="start_date"
                            /> 
                        </div>
                        <div>
                            <label htmlFor="end_date">End Date: </label>

                            <DatePicker
                                ref={endDateRef}
                                selected={formData.end_date_obj}
                                onChange={(date) => {handleDateChange(date, 'end_date');
                                    setTimeout(() => {
                                        const input = endDateRef.current?.input;
                                        if (input) {
                                            const len = input.value.length;
                                            input.setSelectionRange(len, len);
                                        }
                                    }, 0);
                                }}
                                name="end_date"
                                id="end_date"
                            />
                            {formErrors.end_date && (
                                <div className="error">{formErrors.end_date}</div>
                            )}
                        </div>
                        <div>
                            <input type="submit" value="Submit" className="orders-toggle-btn" />
                            <button className="orders-toggle-btn" type="button"
                            // onClick={() => {handlePrint();}}
                            onClick={exportSalesCSV}
                            >Export</button>
                        </div>
                    </div>
                </form>
                {loading ? (
                    <p className="sales-report-empty">Loading...</p>
                ) : sales.length === 0 ? (
                    <p className="sales-report-empty">No records found.</p>
                ) : (
                    <>
                    <div className="sales-report-table-wrapper">
                        <div className="desktop-sales-table">
                            <table className="sales-report-table">
                                <thead>
                                    <tr>
                                    <th>ID</th>
                                    <th>Estimate #</th>
                                    <th>Customer Name</th>
                                    <th>Total</th>
                                    <th>Date</th>
                                    {/* <th>Orders</th> */}
                                    <th style={{textAlign:"center"}}>Actions</th>
                                    </tr>
                                </thead>
                                {currentSales.map((sale) => {
                                    const id = sale.estimate_id ?? sale.id ?? sale.estimate_id;
                                    const estimateNumber = sale.estimate_number ?? sale.estimate_no ?? sale.estimate ?? "—";
                                    const customerName = sale.customer_name ?? sale.customer ?? sale.customerName ?? "—";
                                    const total = sale.total_amount ?? sale.total ?? sale.grand_total ?? 0;
                                    const date = sale.estimate_date ?? sale.created_at ?? sale.date ?? sale.created ?? "";
                                    const isExpanded = expandedId === id;
                                    return (
                                        <tbody key={id}>
                                            {/* <React.Fragment> */}
                                            <tr>
                                                <td>{id}</td>
                                                <td>{estimateNumber}</td>
                                                <td>{customerName}</td>
                                                <td>₹{Number(total).toFixed(2)}</td>
                                                <td>{date ? new Date(date).toLocaleString() : "—"}</td>
                                                <td>
                                                <a className="orders-toggle-btn" href={"/edit-estimate/"+id}>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </a>
                                                <button
                                                    type="button"
                                                    className="orders-toggle-btn"
                                                    onClick={() => handleDelete(id)}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="orders-toggle-btn"
                                                    onClick={() => toggleOrders(id, sale)}
                                                >
                                                    <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} />
                                                    View Order
                                                </button>
                                                </td>
                                            </tr>
                                            {isExpanded && (
                                                <tr className="order-details-row">
                                                    <td colSpan={6}>
                                                        <div className="order-details-panel">
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <h4>Order Items</h4>
                                                                <span>
                                                                    <button className="orders-toggle-btn" style={{marginBottom: "5px"}} 
                                                                    // onClick={() => printSale(sale)}
                                                                    onClick={() => {setSelectedInvoice(sale); setShowPrintPopup(true);}}
                                                                    // onClick={() => exportInvoiceCSV(sale)}
                                                                    >
                                                                        Print
                                                                    </button>
                                                                    <button className="orders-toggle-btn" style={{marginBottom: "5px"}} onClick={handleSharePDF}>
                                                                        Share PDF
                                                                    </button>
                                                                </span>
                                                            </div>
                                                            {!orderItems[id] ? (
                                                                <p className="order-details-loading">Loading...</p>
                                                            ) : orderItems[id].length === 0 ? (
                                                                <p className="order-details-empty">No items in this order.</p>
                                                            ) : (
                                                                <table className="order-items-table">
                                                                    <thead>
                                                                        <tr>
                                                                        <th>Item</th>
                                                                        <th>Qty</th>
                                                                        <th>Unit Price</th>
                                                                        <th>Total</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {orderItems[id].map((item, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{item.item_name ?? item.name ?? item.product ?? "—"}</td>
                                                                                <td>{item.quantity ?? item.qty ?? "—"}</td>
                                                                                <td>₹{Number(item.unit_price ?? item.unit_cost ?? 0).toFixed(2)}</td>
                                                                                <td>₹{Number(item.total ?? item.line_total ?? 0).toFixed(2)}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            {/* </React.Fragment> */}
                                        </tbody>
                                    );
                                })}
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalItems={sales.length}
                                itemsPerPage={reportPerPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                        <div className="mobile-sales-table">
                            <table className="sales-report-table">
                                <thead>
                                    <tr>
                                    <th>Estimate Details</th>
                                    <th>Actions</th>
                                    </tr>
                                </thead>
                                {currentSales.map((sale) => {
                                    const id = sale.estimate_id ?? sale.id ?? sale.estimate_id;
                                    const estimateNumber = sale.estimate_number ?? sale.estimate_no ?? sale.estimate ?? "—";
                                    const customerName = sale.customer_name ?? sale.customer ?? sale.customerName ?? "—";
                                    const total = sale.total_amount ?? sale.total ?? sale.grand_total ?? 0;
                                    const date = sale.estimate_date ?? sale.created_at ?? sale.date ?? sale.created ?? "";
                                    const isExpanded = expandedId === id;
                                    return (
                                        <tbody key={id}>
                                            {/* <React.Fragment> */}
                                            <tr>
                                                <td style={{fontSize: "12px"}}>
                                                    ID: {id}<br />
                                                    Estimate #: {estimateNumber}<br />
                                                    Customer Name: {customerName}<br />
                                                    Total: ₹{Number(total).toFixed(2)}<br />
                                                    Date: {date ? new Date(date).toLocaleString() : "—"}
                                                </td>
                                                <td>
                                                <a className="orders-toggle-btn" href={"/edit-estimate/"+id}>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </a>
                                                <button
                                                    type="button"
                                                    className="orders-toggle-btn"
                                                    onClick={() => handleDelete(id)}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="orders-toggle-btn"
                                                    onClick={() => toggleOrders(id, sale)}
                                                >
                                                    <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} />
                                                    View Order
                                                </button>
                                                </td>
                                            </tr>
                                            {isExpanded && (
                                                <tr className="order-details-row">
                                                    <td colSpan={2}>
                                                        <div className="order-details-panel">
                                                        <h4>Order Items</h4>
                                                        <button className="orders-toggle-btn" style={{marginBottom: "5px"}} 
                                                        // onClick={() => printSale(sale)}
                                                        onClick={() => {setSelectedInvoice(sale); setShowPrintPopup(true);}}
                                                        // onClick={() => exportInvoiceCSV(sale)}
                                                        >
                                                            Print
                                                        </button>
                                                        <button className="orders-toggle-btn" style={{marginBottom: "5px"}} onClick={handleSharePDF}>
                                                            Share PDF
                                                        </button>
                                                        {!orderItems[id] ? (
                                                            <p className="order-details-loading">Loading...</p>
                                                        ) : orderItems[id].length === 0 ? (
                                                            <p className="order-details-empty">No items in this order.</p>
                                                        ) : (
                                                            <table className="order-items-table">
                                                                <thead>
                                                                    <tr>
                                                                    <th>Item</th>
                                                                    <th>Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {orderItems[id].map((item, idx) => (
                                                                        <tr key={idx}>
                                                                            <td>
                                                                                {item.item_name ?? item.name ?? item.product ?? "—"}<br />
                                                                                <span style={{fontSize: "12px"}}>
                                                                                Qty: {item.quantity ?? item.qty ?? "—"}<br />
                                                                                Unit Price: ₹{Number(item.unit_price ?? item.unit_cost ?? 0).toFixed(2)}
                                                                                </span>
                                                                            </td>
                                                                            <td>₹{Number(item.total ?? item.line_total ?? 0).toFixed(2)}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            {/* </React.Fragment> */}
                                        </tbody>
                                    );
                                })}
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalItems={sales.length}
                                itemsPerPage={reportPerPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                    </>
                )}
            </div>
            <div style={{height:"75vh",width:"100%",zIndex:1}}></div>
            {showPrintPopup && (
                <div className="modal-overlay">
                    <div className="modal-content">
                    <h3 style={{margin: "2px 0px", textAlign: "center"}}>Select Print Size</h3>

                    <button onClick={() => printSale("receipt-58mm")}>
                        Print 2"
                    </button>

                    {/* <button onClick={() => printSale("receipt-152mm")}>
                        Print 6"
                    </button> */}
                       <button onClick={() => printSale("invoice-a4")}>
                        Print A4
                    </button>

                    <button onClick={() => printSale("invoice-a4")}>
                        Print A5
                    </button>

                    <button onClick={() => setShowPrintPopup(false)}>
                        Cancel
                    </button>
                    </div>
                </div>
            )}
            <div 
            // ref={contentOrderRef} 
            ref={(el) => {
                contentOrderRef.current = el;
                invoiceRef.current = el;
            }}
            className={`printContent ${printType}`}>
                {selectedInvoice && (() => {
                    const items = orderItems[selectedInvoice.estimate_id] || [];
                    const subTotal = items.reduce((sum, i) => sum + Number(i.sub_total || 0), 0);
                    const totalSGST = Number(selectedInvoice.tax_one || 0);
                    const totalCGST = Number(selectedInvoice.tax_two || 0);
                    const roundOff = Number(selectedInvoice.roundoff || 0);
                    const grandTotal = subTotal + totalSGST + totalCGST + roundOff;
                    const [quotationDate, quotationTime] = selectedInvoice.estimate_date.split(' ');

                    const totalInWords = toWords(Math.floor(grandTotal)); 
                    const decimalPart = Math.round((grandTotal - Math.floor(grandTotal)) * 100);

                    let totalInWordsWithDecimals = decimalPart
                        ? `INR ${totalInWords} and ${toWords(decimalPart)} paise`
                        : `INR ${totalInWords}`;

                    totalInWordsWithDecimals = capitalizeWords(totalInWordsWithDecimals);
                    const { FIRST: MAX_ROWS_FIRST, LAST: MAX_ROWS_LAST } = getRowConfig(printType || "receipt-152mm");
                    const lines = orderItems[selectedInvoice.estimate_id] || [];
                    // const paginateItems = (items) => {
                    //     const pages = [];
                    //     let remaining = [...items];

                    //     while (remaining.length > 0) {
                    //         if (remaining.length > MAX_ROWS_FIRST) {
                    //         pages.push(remaining.slice(0, MAX_ROWS_FIRST));
                    //         remaining = remaining.slice(MAX_ROWS_FIRST);
                    //         } else {
                    //         if (remaining.length <= MAX_ROWS_LAST) {
                    //             pages.push(remaining);
                    //         } else {
                    //             // Distribute so last page is small (2–3 items)
                    //             const lastPageCount = Math.min(3, remaining.length);
                    //             const secondLastCount = remaining.length - lastPageCount;

                    //             pages.push(remaining.slice(0, secondLastCount)); // e.g. 5
                    //             pages.push(remaining.slice(secondLastCount));    // e.g. 2–3
                    //         }
                    //         break;
                    //         }
                    //     }

                    //     return pages;
                    // };
                    const paginateItems = (items) => {
                        const pages = [];
                        let remaining = [...items];

                        while (remaining.length > 0) {
                            if (remaining.length > MAX_ROWS_FIRST) {
                            pages.push(remaining.slice(0, MAX_ROWS_FIRST));
                            remaining = remaining.slice(MAX_ROWS_FIRST);
                            } else {
                            if (remaining.length <= MAX_ROWS_LAST) {
                                pages.push(remaining);
                            } else {
                                // Distribute so last page is small (2–3 items)
                                const lastPageCount = Math.min(3, remaining.length);
                                const secondLastCount = remaining.length - lastPageCount;

                                pages.push(remaining.slice(0, secondLastCount)); // e.g. 5
                                pages.push(remaining.slice(secondLastCount));    // e.g. 2–3
                            }
                            break;
                            }
                        }

                        return pages;
                    };
                    // const paginateItems = (items) => {
                    // const pages = [];

                    // // If items fit in first page → no split
                    // if (items.length <= MAX_ROWS_FIRST) {
                    //     pages.push(items);
                    //     return pages;
                    // }

                    // let remaining = [...items];

                    // //  First page
                    // pages.push(remaining.slice(0, MAX_ROWS_FIRST));
                    // remaining = remaining.slice(MAX_ROWS_FIRST);

                    // //  Remaining pages
                    // while (remaining.length > 0) {
                    //     pages.push(remaining.slice(0, MAX_ROWS_FIRST));
                    //     remaining = remaining.slice(MAX_ROWS_FIRST);
                    // }

                    // return pages;
                    // };

                    const pages = paginateItems(lines);
                    let runningIndex = 0;

                    return (
                        <>
                            <div className="receipt receipt-58mm">
                                <h2 className="center bold" style={{marginBottom: "0"}}>{companyDetail.company_name}</h2>
                                <div className="center small">
                                    <span>{companyDetail.company_address}</span><br />
                                    <span>GST No.: {companyDetail.gst_number}</span>
                                </div>
                                <div className="dash-line"></div>    
                                <h2 className="center bold">QUOTATION</h2>

                                <div className="center small">
                                    <span>
                                        Quote #: {selectedInvoice.estimate_number}
                                    </span>
                                    <br />
                                    {/* Payment: {selectedInvoice.payment_type === "cash" ? "Cash" : "Credit"}
                                    <br /> */}
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <span>{quotationDate}</span>
                                        <span>{quotationTime}</span>
                                    </div>
                                </div>

                                <div className="dash-line"></div>

                                <div className="items-header">
                                    <span>Qty</span>
                                    <span>Item</span>
                                    <span className="right">Price</span>
                                </div>

                                <div className="dash-line"></div>

                                {(orderItems[selectedInvoice.estimate_id] || []).map((item, idx) => ( 
                                    <div key={idx} className="item-row">
                                        <span style={{textAlign: "center", width: "21px"}}>{item.quantity}</span>
                                        <span className="item-name">{item.item_name}</span>
                                        <span className="right">₹{Number(item.total || 0).toFixed(2)}</span>
                                    </div>
                                ))}

                                <div className="dash-line"></div>

                                <div className="dash-line"></div>
                                <div className="row total bold">
                                    <span>TOTAL:</span>
                                    <span>₹{grandTotal.toFixed(2)}</span>
                                </div>
                                <div className="dash-line"></div>
                                <div className="dash-line"></div>

                                <div className="center thanks">*** THANK YOU ***</div>

                            </div>


                    {/* 152mm receipt & A4 invoice */}
                     {pages.map((pageItems, pageIndex) => {
                    const isLastPage = pageIndex === pages.length - 1;

                    const maxRows = isLastPage ? MAX_ROWS_LAST : MAX_ROWS_FIRST;
                    const emptyRows = Math.max(0, maxRows - pageItems.length);
                    const startIndex = runningIndex;
                    runningIndex += pageItems.length;


                    // const isLastPage = pageIndex === pages.length - 1;

                    // // Reserve space for footer ONLY on last page
                    // const FOOTER_RESERVED_ROWS = 8; // adjust based on your footer height

                    // const maxRows = isLastPage
                    // ? MAX_ROWS_FIRST - FOOTER_RESERVED_ROWS
                    // : MAX_ROWS_FIRST;

                    // const emptyRows = Math.max(0, maxRows - pageItems.length);

                    // const startIndex = runningIndex;
                    // runningIndex += pageItems.length;

                    return (
                    <div 
                    // className={printType === "invoice-a4" ? "invoice-a4" : "receipt-152mm"} 
                    className="invoice-a4"
                    key={pageIndex}>
                        <div style={{ fontSize: "14px", padding: "10px", textAlign: "center" }}>Quotation</div>
                        <table className="invoice-table">

                            <thead>
                            {/* Company Section */}
                            <tr>
                                <td style={{ width: "60%", verticalAlign: "top" }}>
                                    <table className="no-border-top no-border-left no-border-bottom" style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <td style={{fontWeight: "700"}}>{companyDetail.company_name}</td>
                                            </tr>
                                            <tr>
                                                <td>{companyDetail.company_address}</td>
                                            </tr>
                                            <tr>
                                                <td>GSTIN: {companyDetail.gst_number}</td>
                                            </tr>
                                            <tr>
                                                <td>Contact: {companyDetail.phone}</td>
                                            </tr>
                                            {/* <tr>
                                                <td>PAN No.:</td>
                                            </tr> */}
                                        </thead>
                                    </table>
                                </td>

                                <td style={{ width: "40%" }}>
                                    <table className="no-border-top no-border-left no-border-right no-border-bottom" style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <td>Date: {quotationDate}</td>
                                            </tr>
                                            <tr>
                                                <td>Quote #: {selectedInvoice.estimate_number}</td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                            </tr>
                                            {/* <tr>
                                                <td>PAN No:</td>
                                            </tr> */}
                                            {/* <tr>
                                                <td>Payment Mode: {selectedInvoice.payment_type === "cash" ? "Cash" : "Credit"}</td>
                                            </tr> */}
                                        </thead>
                                    </table>
                                </td>
                            </tr>

                            {/* Billing Section */}

                            <tr>
                                <td colSpan={2}>
                                    <table className="no-border-bottom no-border-left  no-border-right" style={{ width: "100%" }}>
                                        {selectedInvoice.customer_name && 
                                        <thead>
                                            <tr><td>To</td></tr>
                                            <tr>
                                                <td style={{fontWeight: "700"}}>
                                                    <span style={{fontWeight: "700"}}>{selectedInvoice.customer_name && <>{selectedInvoice.customer_name}</>}</span>
                                                    <span>{selectedInvoice.customer_address && <> {selectedInvoice.customer_address}</>}</span>&nbsp;
                                                    <span>{selectedInvoice.customer_gst_number && <>| GSTIN: {selectedInvoice.customer_gst_number}</>}</span>&nbsp;
                                                    <span>{selectedInvoice.customer_phone_number && <>| Contact: {selectedInvoice.customer_phone_number}</>}</span>&nbsp;
                                                    <span>{selectedInvoice.customer_email && <>| Email ID: {selectedInvoice.customer_email}</>}</span>
                                                </td>
                                            </tr>
                                            {/* <tr>
                                                <td>{selectedInvoice.customer_address && <>{selectedInvoice.customer_address}</>}</td>
                                            </tr>
                                            <tr>
                                                <td>{selectedInvoice.customer_gst_number && <>GSTIN: {selectedInvoice.customer_gst_number}</>}</td>
                                            </tr>
                                            <tr>
                                                <td>{selectedInvoice.customer_phone_number && <>Contact: {selectedInvoice.customer_phone_number}</>}</td>
                                            </tr>
                                            <tr>
                                                <td>{selectedInvoice.customer_email && <>Email ID: {selectedInvoice.customer_email}</>}</td>
                                            </tr> */}
                                        </thead>}
                                    </table>
                                </td>
                                {/* <td style={{ width: "40%" }}></td> */}
                            </tr>

                            {/* Items Table */}
                            <tr>
                                <td colSpan="2">

                                <table className="no-border-left no-border-right invoice-main-table no-border-bottom-th" style={{ width: "100%", padding: "0px" }}>
                                        <colgroup>
                                            <col style={{width: "5%"}} />
                                            <col style={{width: "25%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "10%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "15%"}} />
                                        </colgroup>
                                    <thead>
                                        <tr>
                                            <th style={{fontSize: "12px"}}>Sl No.</th>
                                            <th>Description of Goods</th>
                                            <th>HSN/SAC</th>
                                            <th>Qty</th>
                                            <th>per</th>
                                            <th>Rate</th>
                                            {/* <th>Disc. %</th> */}
                                            <th>Amount</th>
                                        </tr>
                                    </thead></table>
                                      </td>
                                </tr>
                                    </thead>
                                       <tr>
                                <td colSpan="2">
                                <table className="no-border-left no-border-right no-border-top no-border-bottom invoice-main-table" style={{ width: "100%", padding: "0px" }}>
                                 <colgroup>
                                    <col style={{width: "5%"}} />
                                    <col style={{width: "25%"}} />
                                    <col style={{width: "15%"}} />
                                    <col style={{width: "15%"}} />
                                    <col style={{width: "10%"}} />
                                    <col style={{width: "15%"}} />
                                    <col style={{width: "15%"}} />
                                </colgroup>

                                    <tbody>

                                        {/* {(orderItems[selectedInvoice.estimate_id] || []).map((item, idx) => ( 
                                            <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td style={{fontWeight: "700", textAlign: "left"}}>{item.item_name}</td>
                                            <td>{item.hsn_code}</td>
                                            <td>{item.quantity}</td>
                                            <td>{item.unit}</td>
                                            <td>₹{Number(item.unit_price || 0).toFixed(2)}</td>
                                            <td>₹{Number(item.sub_total || 0).toFixed(2)}</td>
                                            </tr>
                                        ))} */}
                                         {pageItems.map((item, idx) => (
                                            <tr key={idx}>
                                                <td>{startIndex + idx + 1}</td>
                                                <td style={{ textAlign: "left", fontWeight: "700" }}>
                                                    {item.item_name}
                                                </td>
                                                <td>{item.hsn_code}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item.unit}</td>
                                                <td>₹{Number(item.unit_price || 0).toFixed(2)}
                                                </td>
                                                <td>₹{Number(item.sub_total || 0).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                           {/*  EMPTY ROWS */}
                                        {Array.from({ length: emptyRows }).map((_, i) => (
                                            <tr key={`empty-${i}`}>
                                                <td>&nbsp;</td>
                                                <td></td><td></td><td></td>
                                                <td></td><td></td><td></td>
                                            </tr>
                                        ))}
                                           </tbody>
                                    
                                </table>
                                
                                </td>
                            </tr>
                                        {/* <tr></tr> */}
                                         {isLastPage && (
                                        <tfoot>
                                            <tr><td colSpan={2}>
                                            <table className="invoice-main-table no-border-left no-border-right no-border-top" style={{ width: "100%" }}>
                                                <colgroup>
                                                  <col style={{width: "5%"}} />
                                                    <col style={{width: "25%"}} />
                                                    <col style={{width: "15%"}} />
                                                    <col style={{width: "15%"}} />
                                                    <col style={{width: "10%"}} />
                                                    <col style={{width: "15%"}} />
                                                    <col style={{width: "15%"}} />
                                                </colgroup>
                                        <tr style={{ fontWeight: "bold", borderTop: "1px solid #111" }}>
                                            <td></td>
                                            <td>Total</td>
                                            <td></td><td></td><td></td><td></td>
                                            <td>₹{grandTotal.toFixed(2)}</td>
                                        </tr>
{/* 
                                    </tbody>

                                </table>

                                </td>
                            </tr> */}
                            </table>
                         </td></tr>

                            <tr>
                                <td colSpan={2} style={{padding: "3px"}}>
                                <div>Amount Chargeable (in words)</div>
                                <div style={{fontWeight: "700"}}>{totalInWordsWithDecimals} only</div>
                                </td>
                            </tr>

                            <tr>
                                <td colSpan={2}>
                                    <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border-left no-border-right">
                                        <colgroup>
                                            <col style={{ width: "50%" }} />
                                            <col style={{ width: "50%" }} />
                                        </colgroup>

                                        <tbody>
                                            <tr>
                                            <td style={{padding: "3px 10px 3px 3px"}}>
                                                <span style={{fontSize: "13px", textDecoration: "underline"}}>Declaration</span><br />
                                                <span>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</span>
                                            </td>
                                            {companyDetail.account_no && 
                                            <td>
                                                <div>Company's Bank Details</div>
                                                <div>Bank Name: {companyDetail.bank_name && <span style={{fontWeight: "700"}}>{companyDetail.bank_name}</span>}</div>
                                                <div>A/c No.: {companyDetail.account_no && <span style={{fontWeight: "700"}}>{companyDetail.account_no}</span>}</div>
                                                <div>Branch & IFS Code: <span style={{fontWeight: "700"}}>{companyDetail.branch && <span>{companyDetail.branch}</span>}
                                                {companyDetail.ifsc && <span> & {companyDetail.ifsc}</span>}</span></div>
                                            </td>}
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                            {/* Footer */}
                            <tr>
                                <td colSpan={2}>
                                    <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border">
                                        <colgroup>
                                            <col style={{ width: "50%" }} />
                                            <col style={{ width: "50%" }} />
                                        </colgroup>

                                        <tbody>
                                            <tr>
                                            <td style={{ height: "80px" }}>
                                                Customer's Seal and Signature
                                            </td>

                                            <td style={{ textAlign: "right", height: "80px", borderLeft: "1px solid #111"}}>
                                                <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
                                                    <div style={{fontWeight: "700"}}>for {companyDetail.company_name}</div>
                                                    <div style={{ marginTop: "auto" }}>Authorised Signatory</div>
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                            </tfoot>)}

                        </table>
                    </div>)})}
                </>
                );
                })()}
            </div>
        </div>
    );
};

export default EstimateReport;